// extracted by mini-css-extract-plugin
export default {"itemPremios":"Menu_itemPremios__eC863","itemPremiosIcone":"Menu_itemPremiosIcone__bJCWG","itemGuincho":"Menu_itemGuincho__qMFZb","itemGuinchoIcone":"Menu_itemGuinchoIcone__wfyiz"};